import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import React from "react";
import i18next from "i18next";
import styled from "styled-components";

const config = {
	default: {
		message: i18next.t("booking:confirmationLabelDefault"),
		color: "#FA8C16",
	},
	confirmed: {
		message: i18next.t("booking:confirmationLabelConfirmed"),
		color: "#7CB305",
	},
	attended: {
		message: i18next.t("booking:confirmationLabelAttended"),
		color: "#145Ab4",
	},

	userConfirmed: {
		message: i18next.t("booking:confirmationLabelUserConfirmed"),
		color: "#7CB305",
		icon: <CheckCircleOutlined />,
	},

	userCanceled: {
		message: i18next.t("booking:confirmationLabelUserCanceld"),
		color: "#F5222D",
		icon: <CloseCircleOutlined />,
	},
};

export const ConfirmationLabel = ({
	confirmedCancelledScreen,
	reservationCofirmed,
	reservationAttended = false,
	userConfirmed,
}) => {
	if (reservationAttended)
		return <WrapperAttended>{config["attended"].message}</WrapperAttended>;

	return (
		<Wrapper
			reservationCofirmed={reservationCofirmed}
			userConfirmed={userConfirmed}
			confirmedCancelledScreen={confirmedCancelledScreen}
		>
			{userConfirmed
				? config[reservationCofirmed].icon
				: confirmedCancelledScreen && config["userCanceled"].icon}
			{userConfirmed
				? config[reservationCofirmed].message
				: confirmedCancelledScreen
				? config.userCanceled.message
				: reservationCofirmed
				? config["confirmed"].message
				: config["default"].message}
		</Wrapper>
	);
};

export const Wrapper = styled.div`
	color: ${(props) =>
		props.userConfirmed
			? config[props.reservationCofirmed].color
			: props.confirmedCancelledScreen
			? config["userCanceled"].color
			: props.reservationCofirmed
			? config["confirmed"].color
			: config["default"].color};
	.anticon {
		margin-right: 5px;
	}
`;

const WrapperAttended = styled.div`
	color: ${config["attended"].color};
`;
